module.exports = __webpack_public_path__ + "img/anfang-coupon-bg.dbe03d83.png";